module.exports = __webpack_public_path__ + "static/img/radio_heart.1575b1e9.svg";